import componentLoader from './component-loader';

componentLoader(document);
